/* Adds test labels to the existing Clarity app. Never installs another recorder.
   Shopify/Google own commerce events, including purchase; clicks are not purchases. */
(function () {
  'use strict';
  var config = document.getElementById('hci-consumer-test');
  if (!config) return;
  var key = 'hci:consumer-5530:v1', campaign = 'hci_5530_consumer_test';
  var query = new URLSearchParams(window.location.search);
  var incoming = query.get('hci_qa') === '1' ? 'qa' :
    (query.get('utm_campaign') === campaign && query.get('utm_source') === 'google' && query.get('utm_medium') === 'cpc' ? 'paid' : null);
  var state = null, started = false, tries = 0, timer, engagementTimer;
  var activeSeconds = 0;
  var cartQuantity = Number(config.dataset.cartQuantity || 0), sent = {};
  // Variant IDs of the consumer-offer product on this page (set by the snippet from its tag).
  var offerVariants = String(config.dataset.variants || '').split(',').filter(Boolean);
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
  }
  function save() {
    if (!state || !allowed()) return;
    state.at = Date.now();
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {}
  }
  function event(name, once) {
    if (!started || !allowed() || !state || typeof window.clarity !== 'function' || (once && sent[name])) return;
    if (once) sent[name] = true;
    window.clarity('event', name);
  }
  function start() {
    // Shopify loads its privacy API asynchronously. An unavailable API is not
    // a refusal: leave the existing consented session untouched until it loads.
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
      config.dataset.trackingState = 'awaiting-privacy-api';
      return;
    }
    if (!allowed()) {
      started = false; state = null;
      window.clearInterval(engagementTimer); engagementTimer = null;
      try { sessionStorage.removeItem(key); } catch (_) {}
      config.dataset.trackingState = 'awaiting-consent';
      return;
    }
    if (typeof window.clarity !== 'function') { config.dataset.trackingState = 'awaiting-clarity'; return; }
    if (started) return;
    var stored;
    try { stored = JSON.parse(sessionStorage.getItem(key)); } catch (_) {}
    if (stored && ['paid', 'qa'].indexOf(stored.cohort) !== -1 && Date.now() - stored.at < 30 * 60 * 1000) state = stored;
    if (incoming && (!state || state.cohort !== incoming)) state = { cohort: incoming, pdp: false };
    if (!state) { config.dataset.trackingState = 'outside-test'; return; }
    started = true;
    config.dataset.trackingState = 'active-' + state.cohort;
    window.clarity('set', 'hci_test', '5530_v1');
    window.clarity('set', 'hci_test_cohort', state.cohort);
    window.clarity('set', 'hci_buyer', config.dataset.role);
    window.clarity('set', 'hci_page_type', config.dataset.page);
    window.clarity('upgrade', 'hci_5530_' + state.cohort);
    if (config.dataset.target === 'true') {
      state.pdp = true;
      event('hci_5530_pdp_view', true);
      if (!engagementTimer && !sent.hci_5530_engaged_15s) {
        engagementTimer = window.setInterval(function () {
          if (allowed() && document.visibilityState === 'visible') activeSeconds++;
          if (activeSeconds >= 15) {
            event('hci_5530_engaged_15s', true);
            window.clearInterval(engagementTimer); engagementTimer = null;
          }
        }, 1000);
      }
    } else if (config.dataset.page === 'index' && state.pdp) {
      event('hci_home_after_pdp', true);
    } else if (config.dataset.page === 'cart') {
      event('hci_consumer_cart_view', true);
    } else if (config.dataset.page === 'page') {
      event('hci_consumer_info_page', true);
    } else if (config.dataset.page === 'collection' || config.dataset.page === 'search') {
      event('hci_consumer_catalogue_visit', true);
    }
    if (document.querySelector('.tpdp[data-auth="gated"]')) event('hci_gated_product_view', true);
    save();
  }
  document.addEventListener('visitorConsentCollected', start);
  start();
  timer = window.setInterval(function () {
    start();
    if (started || ++tries >= 30) window.clearInterval(timer);
  }, 1000);
  document.addEventListener('click', function (e) {
    var target = e.target.closest && e.target.closest('a,button,summary');
    if (!target) return;
    if (target.matches('[name="checkout"]')) event('hci_checkout_clicked', true);
    if (target.matches('[data-open-account]')) event('hci_account_clicked', true);
    if (target.matches('[data-panel-target], [role="tab"], summary')) event('hci_product_details_opened', true);
    if (target.tagName === 'A') {
      var link = new URL(target.href, window.location.origin);
      if (link.origin === window.location.origin && link.pathname === '/') event('hci_home_clicked', true);
      if (link.hash === '#store-reviews') event('hci_reviews_clicked', true);
    }
    save();
  });
  // The redirecting consumer buy box emits Shopify's confirmed added quantities.
  document.addEventListener('hci:cart-added', function (e) {
    var items = e.detail && e.detail.items;
    if (!Array.isArray(items)) return;
    var added = items.reduce(function (n, item) { return n + (offerVariants.indexOf(String(item.variant_id || item.id)) !== -1 ? Number(item.quantity) : 0); }, 0);
    if (added > 0) { event('hci_5530_add_success', false); cartQuantity += added; save(); }
  });
  document.addEventListener('hci:cart-updated', function (e) {
    var items = e.detail && e.detail.items;
    if (!Array.isArray(items)) return;
    var next = items.reduce(function (n, item) { return n + (offerVariants.indexOf(String(item.variant_id || item.id)) !== -1 ? Number(item.quantity) : 0); }, 0);
    if (next > cartQuantity) event('hci_5530_add_success', false);
    cartQuantity = next;
    save();
  });
  window.addEventListener('scroll', function () {
    if (config.dataset.target !== 'true') return;
    var remaining = document.documentElement.scrollHeight - window.innerHeight;
    if (remaining > 0 && window.scrollY / remaining >= 0.5) event('hci_5530_scroll_50', true);
  }, { passive: true });
}());
